import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import ProtectedRoute from './auth/ProtectedRoute'
import LoginCallback from './auth/LoginCallback'
import AdminApp from './AdminApp'

const AppRouter: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <AdminApp />
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default AppRouter
